// @flow

export const numberToPercentString = (num: number): string => {
  const str = String(num).replace(/\.(?=[^.]*$)/g, ',')
  return `${str} %`
}

const numberToKrString = (num: number): string => {
  const str = parseFloat(num)
    .toFixed(0)
    .replace(/./g, (c, i, a) => {
      return i && c !== '.' && (a.length - i) % 3 === 0 ? ' ' + c : c
    })

  return `${str} kr`
}

const numberToUSDString = (num: number): string => {
  const str = parseFloat(num)
    .toFixed(2)
    .replace(/./g, function(c, i, a) {
      return i && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c
    })
  return `$${str}`
}

const numToNegative = (num: number): string => {
  return String(num > 0 ? `-${num}` : Math.abs(num))
}

export const parseUnitsToString = (field: Object, dataObject: Object): string => {
  try {
    switch (field.unit) {
      case 'celsiusMinus':
        return numToNegative(dataObject[field.id]) + 'ºC'
      case 'celsius':
        return dataObject[field.id] + 'ºC'
      case 'USD':
        return numberToUSDString(dataObject[field.id])
      case 'kr':
        return numberToKrString(dataObject[field.id])
      case '%':
        return numberToPercentString(dataObject[field.id])
      case null:
      default:
        return isNaN(dataObject[field.id])
          ? dataObject[field.id]
          : // TODO: write this function manually as Node only ships with en-US locale :(
          Number(dataObject[field.id]).toLocaleString('nb-NO')
    }
  } catch (err) {
    console.error(err)
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/parseUnits/parseUnits.js